import { createFileRoute } from '@tanstack/react-router';
import { AccessPage } from '@/features/access/page';
import { requirePermission } from '@/features/auth/access';
export const Route = createFileRoute('/_authenticated/system/positions')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'positions:read'),
  component: () => <AccessPage kind="positions" />,
});
